module.exports = __webpack_public_path__ + "static/Logo_tracker_google-calendar-3da349c58664229e1fe22dd496e79116.svg";